// extracted by mini-css-extract-plugin
export default {"title":"styles_title__hScsY","titleText":"styles_titleText__ft7lA"};